module.exports = __webpack_public_path__ + "static/media/ship_brown.24f0792f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_brown.png
// module id = 200
// module chunks = 0